import { render } from "./Argumentation.vue?vue&type=template&id=7b63b9d6"
import script from "./Argumentation.vue?vue&type=script&setup=true&lang=js"
export * from "./Argumentation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserTest/Argumentation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b63b9d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b63b9d6', __exports__)) {
    api.reload('7b63b9d6', __exports__)
  }
  
  module.hot.accept("./Argumentation.vue?vue&type=template&id=7b63b9d6", () => {
    api.rerender('7b63b9d6', render)
  })

}


export default __exports__